import { apiClient } from './api.client';

export interface CompanyConfiguration {
  company_id: number;
  brand_name: string;
  logo_url: string | null;
  favicon_url: string | null;
  primary_color: string;
  secondary_color: string;
  login_background: string | null;
  login_title: string;
  login_subtitle: string;
  company_email: string | null;
  company_phone: string | null;
  company_address: string | null;
  footer_text: string;
  theme_mode: string;
  event_retention_days: number;
}

export interface UpdateConfigurationRequest {
  brand_name?: string;
  logo_url?: string | null;
  favicon_url?: string | null;
  primary_color?: string;
  secondary_color?: string;
  login_background?: string | null;
  theme_mode?: string;
  login_title?: string;
  login_subtitle?: string;
  footer_text?: string;
  event_retention_days?: number;
}

class ConfigurationService {
  private endpoint = '/configuration';

  /**
   * Get company configuration
   */
  async getConfiguration(): Promise<CompanyConfiguration> {
    return await apiClient.get<CompanyConfiguration>(this.endpoint);
  }

  /**
   * Update company configuration
   */
  async updateConfiguration(config: UpdateConfigurationRequest): Promise<{ message: string }> {
    return await apiClient.put<{ message: string }>(this.endpoint, config);
  }

  /**
   * Upload image and get base64 data URL
   */
  async uploadImage(imageType: 'logo' | 'favicon' | 'login_bg', file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onloadend = () => {
        const dataUrl = reader.result as string;
        resolve(dataUrl);
      };
      
      reader.onerror = () => {
        reject(new Error('Failed to read file'));
      };
      
      reader.readAsDataURL(file);
    });
  }
}

export const configurationService = new ConfigurationService();
